import { render, staticRenderFns } from "./DriverTips.vue?vue&type=template&id=66b56d5a&scoped=true&"
import script from "./DriverTips.vue?vue&type=script&lang=js&"
export * from "./DriverTips.vue?vue&type=script&lang=js&"
import style0 from "./DriverTips.vue?vue&type=style&index=0&id=66b56d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b56d5a",
  null
  
)

export default component.exports